import { render, staticRenderFns } from "./LoadingInProgress.vue?vue&type=template&id=a20d3c44"
import script from "./LoadingInProgress.vue?vue&type=script&lang=js"
export * from "./LoadingInProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports